import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { toggleCC, toggleMute } from '../slices/ui';
export function buildUiStateMiddleware(adapter) {
    const middleware = createListenerMiddleware();
    const runtimeStartListening = middleware.startListening;
    runtimeStartListening({
        // ui reducer will enable closed captioning if audio gets muted so we
        // need to ensure we always persist both values
        matcher: isAnyOf(toggleCC, toggleMute),
        effect: (action, listenerApi) => {
            const state = listenerApi.getState();
            adapter('cc', state.ui.cc);
            adapter('muted', state.ui.muted);
        },
    });
    return middleware;
}
//# sourceMappingURL=uiState.js.map